import type { SortDirection } from '@/objects/generated';
import type { SortDirection as AgSortDirection } from 'ag-grid-community';

/**
 * Convert the ag-grid sort to our sort direction
 * @param sort
 */
export const agSortToSortDirection = (sort: AgSortDirection | undefined | null): SortDirection | null => {
    return sort == 'asc' ? 'Ascending' : sort == 'desc' ? 'Descending' : null;
};

/**
 * Convert our sort direction to ag-grid sort
 * @param sort
 */
export const sortDirectionToAgSort = (sort: SortDirection | undefined | null) => {
    return sort == 'Ascending' ? 'asc' : sort == 'Descending' ? 'desc' : null;
};
